module.exports = __webpack_public_path__ + "img/arrow_back.1fcb01f2.svg";